import { currencies } from "../../constants/currencies";
import { getCurrencyConversionRates } from "./converionHandlers";

const conversionToDefaultCurrencyHandler = ({
  inputCurrency,
  outputCurrency,
  amount,
  conversionRates,
}) => {
  const parsedAmount = parseInt(amount);
  console.log(parsedAmount, outputCurrency, conversionRates, `conversionToDefaultCurrencyHandler`)

  if (inputCurrency && outputCurrency) {
    const rates = getCurrencyConversionRates(conversionRates);
    return Math.floor(parsedAmount * rates[inputCurrency][outputCurrency]);
  } else {
    if (outputCurrency === currencies.CAD) {
      return parsedAmount;
    } else if (outputCurrency === currencies.USD) {
      return Math.floor(parsedAmount * conversionRates?.USD);
    } else if (outputCurrency === currencies.MTK) {
      return Math.floor(parsedAmount * conversionRates?.MTK);
    } else if (outputCurrency === currencies.USDT) {
      return Math.floor(parsedAmount * conversionRates?.USDT);
    } else {
      return Math.floor(parsedAmount * conversionRates?.NGN);
    }
  }
};

export {
  conversionToDefaultCurrencyHandler
};